// FIXME: Module level logging
const browserBunyan = require('browser-bunyan');
const clientloggersettings = require('./config/clientLoggerConfig').LOGGER;

let clientInstance = null;
const moduleExport = {};

/**
 *
 * @param {string} subModuleName
 * @returns {logger}
 */
const getBrowserBunyanInstance = function (subModuleName) {
  if (!clientInstance) {
    clientInstance = browserBunyan.createLogger({
      name: clientloggersettings.appName,
      streams: [{
        level: clientloggersettings.level,
        stream: new browserBunyan.ConsoleFormattedStream(),
      }],
      serializers: browserBunyan.stdSerializers,
      src: true, // false
    });
  }

  return clientInstance.child({
    submodule: subModuleName,
  });
};

moduleExport.getBrowserBunyanInstance = getBrowserBunyanInstance;
module.exports = moduleExport;
